import { BroadcastDetailsPage } from "./BroadcastDetailsPage";

export const AddBroadcastPage = () => <BroadcastDetailsPage />;
